import React, {useEffect, useState} from 'react';
import styleCom from "./REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";
import DatePicker from "components/DatePicker/DatePicker";
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import Button from "components/Button/Button";


const RenderHtml = (props) => {

    const initObjCartBp = [
        {
             mstId: props.workId  ,hsptCd: props.workHsptCd
            ,cindex:"" ,regYmd:"" ,regHh:"",regMm:""
            ,csys:""   ,cdia:""     ,cpr:""
        }
    ];
    //const [editCartBp, setEditCartBp] = useState(props.dsCartBp);`
    const [rows_subjectList, setRows_subjectList] = useState(props.dsCartBp);
    const cols_subjectList = [
         { key: 'cartTime', name: '일시',   width: '20%' }
        ,{ key: 'sbp',      name: 'SBP(mmHg)', width: '20%' }
        ,{ key: 'dbp',      name: 'DBP(mmHg)', width: '20%' }
        ,{ key: 'mbp',      name: 'MBP(mmHg)', width: '20%' }
        ,{ key: 'pulse',    name: 'Pulse',     width: '20%' }
    ];

    const [editIdx, setEditIdx] = useState('');
    // const [dtlSno, setDtlSno] = useState('');
    // const [dtlRegYmd, setDtlRegYmd] = useState('');
    // const [dtlRegHh, setDtlRegHh] = useState('');
    // const [dtlRegMm, setDtlRegMm] = useState('');
    // const [dtlSbp, setDtlSbp] = useState('');
    // const [dtlDbp, setDtlDbp] = useState('');
    // const [dtlPr, setDtlPr] = useState('');



    /* Tool ****************************************************************************** */



    /* Event ****************************************************************************** */

    //Form load - CART BP
    // useEffect(() => {
    //     //setRows_subjectList(props.dsCartBp);
    // }, []);

    const compChange = (mapCd, value) => {
        //props.setDtlValue(mapCd, value);
        /* Lesion 추가이벤트 처리
         * MLD(le026), RVD(le027) 입력시 하단의 MLD(le073),RVD(le074)도 같이 입력 */
        switch (mapCd) {
            case '':
                //props.setDtlValue(le073, value);
                break;
            default:
                break;
        }

    }



     // useEffect(() => {
     //     setRows_subjectList(editCartBp);
     //     props.setDsCartBp(editCartBp);
     //
     // }, [editCartBp]);

    /* ****************************************************************************** Event */

    let cartBpHtml=<></>;

    cartBpHtml =
        <>
            <div className={styleCom.title_wrap}>
                <h3>CART BP (View)</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <div>
                    <DataGrid
                        cols={cols_subjectList}
                        rows={rows_subjectList}
                        rowHeight={37}
                        // onCellClick={(e) => handleClick_DtlGrid_row(e)}
                        sortable={true}
                        isNodataView={true}
                    />
                </div>
            </div>


        </>
    ;


    let renderHtml =
        <></>
    ;

    if (props.contentId === "T3") {
        renderHtml = cartBpHtml;

    } else {

    }
    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

